const TN = {
  ibanLength: 24,
};
export { TN };
